import { createFileRoute } from '@tanstack/react-router';
import { PositionsPage } from '@/features/tenant/pages/positions-page';

export const Route = createFileRoute('/_app/settings/positions')({ component: PositionsPage });
